import { Input } from "@/components/Input";
import SubLayout from "@/components/SubLayout";
import { Button, Form, Space, TextArea } from "antd-mobile";
import { useLogic } from "./logic";
export function PageUserReport() {
  const logic = useLogic();
  return <SubLayout title={"意见反馈"} footer={<Button className={"common-submit-button"} onClick={() => {
    logic.submit();
  }}>
          提交
        </Button>} data-sentry-element="SubLayout" data-sentry-component="PageUserReport" data-sentry-source-file="index.tsx">
      <Form form={logic.form} className={"common-form"} data-sentry-element="Form" data-sentry-source-file="index.tsx">
        <Form.Item name="title" label="标题" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="请输入标题" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>
        <Form.Item name="content" label={<Space align={"end"}>
              <div>问题描述</div>
              <div>内容介于20~200字</div>
            </Space>} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <TextArea placeholder="请详细描述您遇到的问题，填写内容不少于20字" maxLength={200} rows={8} showCount={false} data-sentry-element="TextArea" data-sentry-source-file="index.tsx" />
        </Form.Item>
      </Form>
    </SubLayout>;
}